import { COMMS_CENTER, COMMS_CENTER_LEGACY_PERMISSION } from '../firewall/permissions';

export function hasCommsCenterAccess(firewall) {
  // in order to maintain backwards compatibility with non GBB cutomers we need to check the old permission type too.
  const hasAccess = firewall.hasAccess(COMMS_CENTER) || firewall.hasAccess(COMMS_CENTER_LEGACY_PERMISSION);

  return hasAccess && firewall.hasRole('admin');
}
